import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('lokakaryaPa', {
      mInstrumen: (state) => state.instrumen || {},
    }),

    instrumens() {
      let result = {};

      for (const keyInstrumen in this.mInstrumen) {
        const instrumens = this.mInstrumen[keyInstrumen] || [];
        result[keyInstrumen] = [];

        for (const ins of instrumens) {
          const items = (ins.opsi || []).map((opsi) => {
            return {
              text: opsi.keterangan,
              value: opsi.k_lokakarya_opsi_psp,
              is_lain: opsi.is_lain,
              validator: opsi.validator,
            };
          });
          const othersValue = items.filter((item) => item.is_lain === 1);
          const otherValue = othersValue[0] || {};

          const validators = (ins.validator || '').split('|');
          let validator = {};
          for (const item of validators) {
            if (item) {
              const val = item.split(':');
              validator[val[0]] = val[1];
            }
          }

          let counter = false;
          if (validator.min_words) {
            counter = validator.min_words;
          } else if (othersValue.length) {
            counter = {};
            for (const val of othersValue) {
              const validators = (val.validator || '').split('|');
              let validator = {};
              for (const item of validators) {
                if (item) {
                  const val = item.split(':');
                  validator[val[0]] = val[1];
                }
              }

              counter[val.value] = validator.min_words || false;
            }
          }

          if (ins.tipe === 'checkbox') {
            const rows = [];

            result[keyInstrumen].push({
              id: (ins.k_lokakarya_instrumen_psp || '').toString(),
              type: 'Checkbox',
              name: `instrumen-checkbox-${ins.k_lokakarya_instrumen_psp}`,
              label: ins.keterangan,
              labelColor: 'indigo',
              items,
              hideDetails: true,
              row: rows.includes(+ins.k_lokakarya_instrumen_psp),
              singleLine: true,
              notitle: true,
              class: 'mb-0',
              grid: { cols: 12 },
              itemGrid: { cols: 12, lg: 4 },
              readonly: this.readOnly,
              useOthers: true,
              othersValue: +otherValue.value,
              others: {
                type: 'VTextarea',
                name: `input-lain-${ins.k_lokakarya_instrumen_psp}-${otherValue.value}`,
                label: 'Tuliskan jawaban lainnya',
                placeholder: 'Tuliskan jawaban lainnya',
                hint: 'wajib diisi',
                required: true,
                outlined: true,
                dense: true,
                singleLine: true,
                hideDetails: true,
                readonly: this.readOnly,
                rows: 2,
                autoGrow: true,
                grid: { cols: 12, md: 6 },
              },
            });
          } else if (ins.tipe === 'radio') {
            const rows = [];
            result[keyInstrumen].push({
              id: (ins.k_lokakarya_instrumen_psp || '').toString(),
              type: 'VRadio',
              name: `instrumen-radio-${ins.k_lokakarya_instrumen_psp}`,
              label: ins.keterangan,
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              hint: 'wajib diisi',
              items,
              customClass: 'mt-0',
              hideDetails: true,
              outlined: true,
              dense: true,
              row: !rows.includes(+ins.k_lokakarya_instrumen_psp),
              singleLine: false,
              grid: { cols: 12, md: 12 },
              readonly: this.readOnly,
              useOthers: true,
              othersValue: othersValue.map((val) => +val.value),
              others: {
                type: 'VTextarea',
                name: `input-lain-${ins.k_lokakarya_instrumen_psp}-${otherValue.value}`,
                label: 'Tuliskan jawaban lainnya',
                placeholder: 'Tuliskan jawaban lainnya',
                hint: 'wajib diisi',
                required: true,
                outlined: true,
                dense: true,
                singleLine: true,
                hideDetails: true,
                readonly: this.readOnly,
                rows: 2,
                autoGrow: true,
                grid: { cols: 12, md: 6 },
              },
            });
          } else if (ins.tipe === 'number') {
            result[keyInstrumen].push({
              id: (ins.k_lokakarya_instrumen_psp || '').toString(),
              type: 'VTextField',
              name: `instrumen-input-${ins.k_lokakarya_instrumen_psp}`,
              label: ins.keterangan,
              labelColor:
                this.isNotEmpty &&
                !this.form[`instrumen-input-${ins.k_lokakarya_instrumen_psp}`] &&
                this.form[`instrumen-input-${ins.k_lokakarya_instrumen_psp}`] !== 0
                  ? 'red'
                  : 'indigo',
              hint: '',
              mask: '#####',
              customClass: 'mt-0',
              placeholder: 'Tuliskan angka',
              outlined: true,
              singleLine: true,
              hideDetails: true,
              dense: true,
              readonly: this.readOnly,
              grid: { cols: 12, md: 6, sm: 12 },
            });
          } else if (ins.tipe === 'textarea') {
            result[keyInstrumen].push({
              id: (ins.k_lokakarya_instrumen_psp || '').toString(),
              type: 'VTextarea',
              name: `instrumen-input-${ins.k_lokakarya_instrumen_psp}`,
              label: ins.keterangan,
              labelColor: validator.min_words
                ? !!this.form[`instrumen-input-${ins.k_lokakarya_instrumen_psp}`] &&
                  this.$wordCount(this.form[`instrumen-input-${ins.k_lokakarya_instrumen_psp}`] || '') <
                    validator.min_words
                  ? 'red'
                  : 'indigo'
                : validator.max_words
                ? !!this.form[`instrumen-input-${ins.k_lokakarya_instrumen_psp}`] &&
                  this.$wordCount(this.form[`instrumen-input-${ins.k_lokakarya_instrumen_psp}`] || '') >
                    validator.max_words
                  ? 'red'
                  : 'indigo'
                : 'indigo',
              customClass: 'mt-0',
              placeholder: `Tuliskan jawaban ${validator.min_words ? `(minimal ${validator.min_words} kata)` : ''}${
                validator.max_words ? `(maksimal ${validator.max_words} kata)` : ''
              }`,
              hint: validator.min_words
                ? `Deskripsi minimal ${validator.min_words} kata`
                : validator.max_words
                ? `Deskripsi maksimal ${validator.max_words} kata`
                : '',
              required: false,
              outlined: true,
              singleLine: true,
              dense: true,
              readonly: this.readOnly,
              rows: 3,
              autoGrow: true,
              counter: true,
              counterValue: (v) => this.$wordCount(v),
              grid: { cols: 12, md: 12, sm: 12 },
            });
          } else if (ins.tipe === 'date') {
            result[keyInstrumen].push({
              id: (ins.k_lokakarya_instrumen_psp || '').toString(),
              type: 'VDatePicker',
              name: `instrumen-input-${ins.k_lokakarya_instrumen_psp}`,
              label: ins.keterangan,
              labelColor: 'indigo',
              usePrependInnerIcon: 'mdi-calendar-month',
              hint: 'wajib diisi',
              outlined: true,
              singleLine: true,
              disabled: this.readOnly,
              hideDetails: true,
              dense: true,
              grid: { cols: 12, md: 12, sm: 12 },
            });
          }
        }
      }

      return result;
    },
  },
};
